import { render, staticRenderFns } from "./firmProp.vue?vue&type=template&id=0fd5ca40&scoped=true&"
import script from "./firmProp.vue?vue&type=script&lang=js&"
export * from "./firmProp.vue?vue&type=script&lang=js&"
import style0 from "./firmProp.vue?vue&type=style&index=0&id=0fd5ca40&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd5ca40",
  null
  
)

export default component.exports